import {
  Component,
  computed,
  effect,
  inject,
  input,
  InputSignal,
  Signal,
  signal,
  TemplateRef,
  WritableSignal,
} from '@angular/core';
import { NgStyle, NgTemplateOutlet } from '@angular/common';
import { CorporateDesignService } from '../../../services/corporate-design/corporate-design.service';

@Component({
  selector: 'aw-burger-menu',
  imports: [NgTemplateOutlet, NgStyle],
  templateUrl: './burger-menu.component.html',
})
export class BurgerMenuComponent {
  public readonly isMenuOpen: WritableSignal<boolean> = signal(false);
  public readonly menuContent: InputSignal<TemplateRef<unknown>> =
    input.required<TemplateRef<unknown>>();
  public corporateDesignService: CorporateDesignService = inject(
    CorporateDesignService
  );
  protected isDarkMode: Signal<boolean> = computed(() => {
    return this.corporateDesignService.isDarkModeActive();
  });

  constructor() {
    effect(() => {
      if (this.isMenuOpen()) {
        document.body.style.overflowY = 'hidden';
      } else {
        document.body.style.overflowY = 'auto';
      }
    });
  }

  public closeMenu(): void {
    this.isMenuOpen.set(false);
  }
}
